"use client";

import { ReactNode } from "react";
import { motion } from "framer-motion";

interface FadeInProps {
  children: ReactNode;
  delay?: number;
  direction?: "up" | "down" | "left" | "right" | "none";
  className?: string;
  viewOffset?: string;
}

export const FadeIn = ({
  children,
  delay = 0,
  direction = "up",
  className = "",
  viewOffset = "-50px",
}: FadeInProps) => {
  const directionOffset = {
    up: { y: 20 },
    down: { y: -20 },
    left: { x: 20 },
    right: { x: -20 },
    none: {},
  }[direction];

  return (
    <motion.div
      variants={{
        initial: { 
          opacity: 0, 
          ...directionOffset 
        },
        animate: { 
          opacity: 1, 
          x: 0, 
          y: 0,
          transition: {
            duration: 0.7,
            delay,
            ease: [0.21, 0.47, 0.32, 0.98],
          }
        },
      }}
      initial="initial"
      whileInView="animate"
      viewport={{ once: true, margin: `0px 0px ${viewOffset} 0px` }}
      className={className}
    >
      {children}
    </motion.div>
  );
};
